<div class="custom-dropdown">
  <div class="input-filtro-selecionado">
    <button type="button" class="dropdown-toggle" (click)="toggleTipoObra()">
      <img
        src="{{ BASE_IMG_URL }}assets/agenda-tarefas/filter.svg"
        width="20"
        height="20"
      />
      {{
        filtroTipoObraSelecionados.length === 0
          ? "Todos os tipos de obra"
          : filtroTipoObraSelecionados.length + " tipo(s) selecionado(s)"
      }}
    </button>
    <button
      *ngIf="filtroTipoObraSelecionados.length"
      type="button"
      class="btn-clear"
      (click)="limparTiposObra()"
    >
      ×
    </button>
  </div>
  <div *ngIf="mostrarTipoObra" class="dropdown-list">
    <label *ngFor="let tipo of tiposObra">
      <input
        type="checkbox"
        [checked]="filtroTipoObraSelecionados.includes(tipo.moduleID)"
        (change)="onTipoObraToggle(tipo.moduleID, $event); onTipoObraChange()"
      />
      {{ tipo.module }}
    </label>
  </div>
</div>
